import { Box, Heading, Text } from '@machobear/design-system'

interface Props {
  label: string
  value: number
  onClick?: () => void
}

export const IndicatorBlock = ({ label, value, onClick }: Props) => (
  <Box
    background="neutralLight"
    borderRadius="standard"
    display="flex"
    flexDirection="column"
    alignItems="flexStart"
    paddingTop="small"
    paddingX="small"
    paddingBottom="medium"
    gap="small"
    cursor={!onClick ? 'default' : 'pointer'}
    style={{
      flex: 1,
      minWidth: '150px'
    }}
    onClick={onClick}
  >
    <Text size="small">{label}</Text>
    <Heading level="4">{value.toLocaleString('en-US')}</Heading>
  </Box>
)
